module.exports = __webpack_public_path__ + "static/media/video-off.ca5a3416.svg";